import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    web1Url: '',
    memberUrl: '',
    urlQuery: '',
};

export const urlSlice = createSlice({
    name: 'url',
    initialState,
    reducers: {
        setWeb1Url: (state, action) => {
            state.web1Url = action.payload;
        },
        setMemberUrl: (state, action) => {
            state.memberUrl = action.payload;
        },
        setUrlQuery: (state, action) => {
            state.urlQuery = action.payload;
        },
    },
});

export const urlState = (state) => state.url;

export const { setWeb1Url, setMemberUrl, setUrlQuery } = urlSlice.actions;

export default urlSlice.reducer;
